import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter } from 'react-router-dom'
import { Toaster, toast } from 'react-hot-toast'
// @ts-ignore - virtual module provided by vite-plugin-pwa
import { registerSW } from 'virtual:pwa-register'

import App from './App'
import './index.css'
import './i18n/i18n'

// Configuración del cliente de React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
    mutations: {
      retry: 1,
    },
  },
})

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  registerSW({
    onNeedRefresh() {
      // Notificación no bloqueante (el callback del SW corre fuera del árbol
      // de React, por eso se usa el toast global en vez de un Modal propio)
      toast((t) => (
        <div className="flex items-center gap-3">
          <span>Nueva versión disponible.</span>
          <button
            onClick={() => {
              toast.dismiss(t.id);
              window.location.reload();
            }}
            className="bg-mava-600 hover:bg-mava-700 text-white px-3 py-1.5 rounded text-sm font-medium whitespace-nowrap"
          >
            Actualizar ahora
          </button>
        </div>
      ), { duration: Infinity });
    },
    onOfflineReady() {
      console.log('App lista para funcionar offline');
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#fff',
              color: '#374151',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            },
            success: {
              iconTheme: {
                primary: '#22c55e',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
)
